import { useLanguage } from "@/context/LanguageContext";
import { content } from "@/content/fitswag";
import Reveal from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  const { lang } = useLanguage();
  const t = content[lang].faq;

  return (
    <section id="faq" className="border-b border-white/10 bg-ink py-24 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-5 md:grid-cols-12 md:px-8">
        <Reveal className="md:col-span-4">
          <p className="overline text-brand-orange">{t.overline}</p>
          <h2 className="mt-3 font-display text-5xl leading-[0.95] tracking-tight text-white md:text-6xl">
            {t.title}
          </h2>
        </Reveal>

        <div className="md:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {t.items.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-white/10"
                >
                  <AccordionTrigger className="py-6 font-display text-xl tracking-tight text-white hover:no-underline md:text-2xl [&>svg]:text-brand-orange">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-base leading-relaxed text-gray-400">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
